module.exports = __webpack_public_path__ + "img/Logo_RGB.bb8ebd5c.jpg";